import React from 'react'

import { Box, Tooltip } from '@chakra-ui/react'
import { useSelector } from 'react-redux'

const ActiveStaffIndicator = ({ active }) => {
  const user = useSelector(state => state.auth.user)

  if (!user.is_admin) return null

  return (
    <Tooltip label={active ? 'Active' : 'Deactivated'}>
      <Box
        p={1}
        display='inline-block'
        borderRadius='full'
        borderColor='papayawhip'
        bg={active ? 'forestgreen' : 'tomato'}
        mr={2}
      />
    </Tooltip>
  )
}

export default ActiveStaffIndicator
